import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    Header, Cell, renderPrice, EmptyCell, Title
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    }
};

const StadiumMatrix = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print landscape'>
            <div><Trigger /></div>

            <Title data={Object.values(data)} title='Stadium Tower'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>

                <Table.Header>
                    <Table.Row>
                        <Header colSpan='100' content='North View' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='M-2/2' />
                        <Header colSpan='2' content='N-2/2' />
                        <Header colSpan='2' content='T-3/2' />
                        <Header colSpan='2' content='R-1/1' />
                        <Header colSpan='2' content='M-2/2' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='1315 sq ft' />
                        <Header colSpan='2' content='1148 sq ft' />
                        <Header colSpan='2' content='1400 sq ft' />
                        <Header colSpan='2' content='800 sq ft' />
                        <Header colSpan='2' content='1080 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        range(12, 4, -1)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(floor => (
                                <Table.Row key={floor}>
                                    {['02', '04', '06', '08', '10'].map(unit => (
                                        <Cell
                                            unit={`${floor}${unit}`}
                                            price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                            status={data[`01-${floor}${unit}`].status}
                                        />
                                    ))}
                                </Table.Row>
                            ))
                    }

                    <Table.Row>
                        <EmptyCell count={2} />
                        <Cell unit='0101' price={renderPrice(data['01-0101'], matrixType)} status={data['01-0101'].status}/>
                        <EmptyCell count={2} />
                    </Table.Row>

                </Table.Body>
            </Table>
            <div className='pagebreak' />
            <div className='printspace' />
            <Title title='Stadium Tower'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>

                <Table.Header>

                    <Table.Row>
                        <Header colSpan='100' content='South View' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='W-1/1' />
                        <Header colSpan='2' content='A-2/1.5' />
                        <Header colSpan='2' content='S-2/2' />
                        <Header colSpan='2' content='H-1/1.5' />
                        <Header colSpan='2' content='M-2/2' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='730 sq ft' />
                        <Header colSpan='2' content='1140 sq ft' />
                        <Header colSpan='2' content='1045 sq ft' />
                        <Header colSpan='2' content='663 sq ft' />
                        <Header colSpan='2' content='1080 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        range(12, 5, -1)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(floor => (
                                <Table.Row key={floor}>
                                    {['01', '03', '05', '07', '09'].map(unit => (
                                        <Cell
                                            unit={`${floor}${unit}`}
                                            price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                            status={data[`01-${floor}${unit}`].status}

                                        />
                                    ))}
                                </Table.Row>
                            ))
                    }

                    <Table.Row>
                        <Cell unit='0501' price={renderPrice(data['01-0501'], matrixType)} status={data['01-0501'].status}/>
                        <Cell unit='0503' price={renderPrice(data['01-0503'], matrixType)} status={data['01-0503'].status}/>
                        <Header colSpan='2' content='D-1/1' />
                        <Cell unit='0507' price={renderPrice(data['01-0507'], matrixType)} status={data['01-0507'].status}/>
                        <Cell unit='0509' price={renderPrice(data['01-0509'], matrixType)} status={data['01-0509'].status}/>
                    </Table.Row>

                    <Table.Row>
                        <EmptyCell count={2} />
                        <Header colSpan='2' content='800 sq ft' />
                        <EmptyCell count={2} />
                    </Table.Row>

                    <Table.Row>
                        <EmptyCell count={2} />
                        <Cell unit='0505' price={renderPrice(data['01-0505'], matrixType)} status={data['01-0505'].status}/>
                        <EmptyCell count={2} />
                    </Table.Row>

                </Table.Body>
            </Table>


        </div>
    );


};

export default StadiumMatrix;
